import { Pagination } from '@/components/custom/pagination'

interface PaginationWrapperProps {
  pageCount: number
  currentPage: number
  onPageChange: (page: number) => void
  className?: string
}

export function PaginationWrapper({
  pageCount,
  currentPage,
  onPageChange,
  className = 'flex justify-end',
}: PaginationWrapperProps) {
  if (pageCount <= 1) {
    return null
  }

  return (
    <div className={className}>
      <Pagination
        page={currentPage}
        pageCount={pageCount}
        onPageChange={onPageChange}
      />
    </div>
  )
}
